import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';

export const ScooberAppsLayout = () => {
  const ScooberCookieStatement = React.lazy(
    () => import('@src/apps/ScooberApps/components/ScooberCookieStatement')
  );
  const ScooberPrivacyPolicies = React.lazy(
    () =>
      import('@src/apps/ScooberApps/components/ScooberPrivacyPolicies')
  );
  const ScooberTechnologies = React.lazy(
    () => import('@src/apps/ScooberApps/components/ScooberTechnologies')
  );


  return (
    <Router basename="/apps">
      <Switch>
        <Route exact path="/privacy-statement">
          <ScooberPrivacyPolicies />
        </Route>
        <Route exact path="/cookie-statement">
          <ScooberCookieStatement />
        </Route>
        <Route exact path="/technology-listing">
          <ScooberTechnologies />
        </Route>
        <Route exact path="*">
          <Redirect to="/privacy-statement" />
        </Route>
      </Switch>
    </Router>
  );
};
